import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=1e969926&scoped=true&"
import script from "./NavigationItem.vue?vue&type=script&lang=ts&"
export * from "./NavigationItem.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationItem.vue?vue&type=style&index=0&id=1e969926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e969926",
  null
  
)

export default component.exports